module.exports = __webpack_public_path__ + "img/5_55.2e8bf289.png";